import { 
    ServerEventResponse, 
    ISiteLookupTable, 
    AnnArborSiteID, 
    DearbornSiteID, 
    FlintSiteID 
} from "@/types/sse-types";
import { storeToRefs } from 'pinia';
import { useAnnArbor } from "@/stores/sites/ann-arbor";
import { useFlint } from "@/stores/sites/flint";
import { useDearborn } from "@/stores/sites/dearborn";

const AnnArborState = useAnnArbor();
const { getAnnArborEmergencyCalls, getAnnArborNonEmergencyCalls } = storeToRefs(AnnArborState);

const FlintState = useFlint();
const { getFlintEmergencyCalls, getFlintNonEmergencyCalls } = storeToRefs(FlintState);

const DearbornState = useDearborn();
const { getDearbornEmergencyCalls, getDearbornNonEmergencyCalls } = storeToRefs(DearbornState);


export const siteLookUp: ISiteLookupTable = {
    [AnnArborSiteID] : { 
        name: "Ann Arbor",
        emergency: AnnArborState.emergencyCalls, 
        emergencyGetter: getAnnArborEmergencyCalls,
        nonEmergency: AnnArborState.nonEmergencyCalls,  
        nonEmergencyGetter: getAnnArborNonEmergencyCalls 
    },
    [DearbornSiteID] : { 
        name: "Dearborn",
        emergency: DearbornState.emergencyCalls,  
        emergencyGetter: getDearbornEmergencyCalls,
        nonEmergency: DearbornState.nonEmergencyCalls, 
        nonEmergencyGetter: getDearbornNonEmergencyCalls
    },
    [FlintSiteID] : { 
        name: "Flint", 
        emergency: FlintState.emergencyCalls, 
        emergencyGetter: getFlintEmergencyCalls,
        nonEmergency: FlintState.nonEmergencyCalls,  
        nonEmergencyGetter: getFlintNonEmergencyCalls 
    }
}

export const extractSiteID = (serverEvent: ServerEventResponse) => serverEvent.payload.object.caller.site_id;
export const assignToSite = (serverEvent: ServerEventResponse) => siteLookUp[extractSiteID(serverEvent)];
export const assignCallType = (serverEvent: ServerEventResponse) => serverEvent.payload.object.callee.phone_number == "911" ? true : false;

export const initializeSiteState = async (serverEvents: ServerEventResponse[]) => {
    // console.log("initializeSiteState", serverEvents)
    return serverEvents.map((callObj: ServerEventResponse) => {
        const site = assignToSite(callObj);
        // console.log(site)
        return assignCallType(callObj) 
        ? site.emergency = [...site.emergency, callObj]
        : site.nonEmergency = [...site.nonEmergency, callObj]
    });
}

export const updateSiteState = async (callObj: ServerEventResponse) => {
    console.log("updateSiteState", callObj);
    const test = extractSiteID(callObj);
    console.log("-------", test)
    const site = assignToSite(callObj);
    console.log("~~~~~~~~~~", site);

    return assignCallType(callObj) 
        ? site.emergency = [...site.emergency, callObj]
        : site.nonEmergency = [...site.nonEmergency, callObj];
}

export const distributeToSite = async (data: ServerEventResponse | ServerEventResponse[]) => 
    Array.isArray(data) ? await initializeSiteState(data) : await updateSiteState(data);